import GatewaySDK from './gateway-sdk'
import AppSettings from './app-settings'

class GatewayPlugin {
  install (Vue, options) {
    Vue.prototype.$sdk = new GatewaySDK(options, Vue.prototype)
    Vue.prototype.$settings = new AppSettings(Vue.prototype.$sdk)
  }
}

export default new GatewayPlugin()



// WEBPACK FOOTER //
// ./src/modules/gateway-sdk/index.js